/**
 @Developper: BenAli Faker
 @Company: SMART-INFO
 @Post: CTO
 @Date:24/06/2021
 @Time:15:46
 **/

//Template script here

(function($) {
    'use strict' ;
  if($("nav").length>0) {
      $('nav').coreNavigation({
          menuPosition: "right",
          container: true,
          mode: 'sticky',
          dropdownEvent: 'hover',
          onInit: function () {
              Begro.logInfo("fixer l'hauteur de coreNavivation standy sticky à 0");
              $(".stand-sticky").addClass('h-0');
          }
      });
  }
    // Dynamic active menu
    var path = window.location.pathname.split("/").pop();
    var target = $('.menu li a[href="'+path+'"]');
    target.parent().addClass('active');
    $('.menu li.active').parents('li').addClass('active');
})(jQuery);// End of use strict